import React, { FC, ReactNode, useContext, useState } from 'react'
import { AppState } from '../../stores/app'
import 'fixed-data-table-2/dist/fixed-data-table.css'
// import './reporting.scss'

import { ReportBuilder, ReportBuilderProps } from './report-builder/report-builder'
import { ReportStatusCode } from './enums/report-status-code'
import { OrgContext } from '../../contexts/org-context'
import { useService } from '@pushly/aqe/lib/hooks'
import { ReportTable } from './report-table/report-table'
import { PlatformLevel } from './enums/platform-level'
import { IReportConfig } from './interfaces/report-config'
import { InsightsReportContract } from './helpers/build-api-report-contract'
import { DomainDto } from '../../dtos/domain'
import { GetAccountResponse } from '@pushly/models/lib/structs'

type ReportingProps = {
    level: PlatformLevel.ORG | PlatformLevel.DOMAIN
    levelId: number
}

export const ReportingV2: FC<ReportingProps> = ({ level, ...props }) => {
    const appState = useService(AppState)
    const [insightsStatus, setInsightsStatus] = useState<{ code?: ReportStatusCode; message?: ReactNode }>({})
    const [insightsConfig, setInsightsConfig] = useState<any>({}) // IReportConfig @todo - fix default value for table read
    const [insights, setInsights] = useState<any[]>([])
    const [apiContract, setApiContract] = useState<InsightsReportContract>()

    // level management - omitted are passed in component with props
    const levelProps: {
        level: PlatformLevel
        domain: DomainDto
        org?: GetAccountResponse
    } = {
        level,
        domain: appState.currentDomain!,
    }

    if (level === PlatformLevel.ORG) {
        const orgContext = useContext(OrgContext)
        levelProps.org = orgContext.org
    }

    return (
        <div className="reporting-v2 page">
            <div className="report-display-wrapper">
                <ReportBuilder
                    {...levelProps}
                    onStatusUpdate={(status) => {
                        setInsightsStatus(status)
                    }}
                    onInsightsUpdate={(data, reportConfig, contract) => {
                        setInsights(data || [])
                        setInsightsConfig(reportConfig)
                        setApiContract(contract)
                    }}
                />
                {insightsStatus.code === ReportStatusCode.ERROR ||
                insightsStatus.code === ReportStatusCode.NO_DATA ||
                insightsStatus.code === ReportStatusCode.NOT_READY ? (
                    <div className="message-wrapper">{insightsStatus.message}</div>
                ) : (
                    <div className="insights-wrapper">
                        <ReportTable
                            {...levelProps}
                            loading={insightsStatus.code === ReportStatusCode.LOADING}
                            config={insightsConfig}
                            data={insights}
                            columns={apiContract?.fields ?? []}
                            hiddenColumns={apiContract?.addtRequiredFields}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}
